import { useCallback, useEffect, useState } from "react";
import { removeToken } from "../utils/auth";
import { useNavigate } from "react-router-dom";
import API from "../services/api";
import "../assets/dash.css";
import { Offcanvas } from "bootstrap";
import { Calendar, Search, User } from "lucide-react";

export default function Dashboard() {
const navigate = useNavigate();

const [rooms, setRooms] = useState([]);
const [loading, setLoading] = useState(true);

const [prices, setPrices] = useState([]);
const [priceLoading, setPriceLoading] = useState(false);

const [editingId, setEditingId] = useState(null);
const [editAmount, setEditAmount] = useState("");
const [priceRefs, setPriceRefs] = useState([]);

const [filters, setFilters] = useState({
  hotel_price_master_id: 1,
  minPrice: "",
  maxPrice: "",
});

const [appliedFilters, setAppliedFilters] = useState({
  hotel_price_master_id: 1,
  minPrice: "",
  maxPrice: "",
});

const handleLogout = () => {
removeToken();
navigate("/");
};

// Fetch Rooms
const fetchRooms = async (customFilters = appliedFilters) => {
  try {
    setLoading(true);

    const res = await API.post("/hotels/room/list/withprice", {
      hotel_price_master_id: customFilters.hotel_price_master_id,
      minPrice: customFilters.minPrice || 0,
      maxPrice: customFilters.maxPrice || 999999,
    });

    setRooms(res.data || []);
  } catch (err) {
    console.log(err);
    alert("Failed to load rooms");
  } finally {
    setLoading(false);
  }
};


const fetchPriceReferences = async () => {
  try {
    const res = await API.get("/filter/price/references");
    setPriceRefs(res.data);
  } catch (err) {
    console.log(err);
  }
};

// Fetch Prices
const fetchPrices = async (roomId) => {
try {
setPriceLoading(true);

  const res = await API.post("/hotels/room/prices", {
    hotel_room_master_id: roomId,
  });

  setPrices(res.data);

  const offcanvas = new Offcanvas(
    document.getElementById("priceOffcanvas")
  );
  offcanvas.show();

} catch (err) {
  console.log(err);
  alert("Failed to load prices");
} finally {
  setPriceLoading(false);
}

};

// Update Price
const updatePrice = async (priceId) => {
if (!editAmount || editAmount <= 0) {
alert("Enter valid price");
return;
}

try {
  await API.post("/hotels/room/price/edit", {
    hotel_room_price_id: priceId,
    hotel_price_amount: editAmount,
  });

  // Update UI instantly
  setPrices((prev) =>
    prev.map((p) =>
      p.hotel_room_price_id === priceId
        ? { ...p, hotel_price_amount: editAmount }
        : p
    )
  );

  setEditingId(null);
  setEditAmount("");

} catch (err) {
  console.log(err);
  alert("Failed to update price");
}

};

useEffect(() => {
  fetchRooms();
  fetchPriceReferences();
}, []);


return ( <div className="layout">

  {/* TOP BAR */}
  <nav className="navbar navbar-expand-lg topbar">
  <div className="container-fluid">

    {/* Logo */}
    <a className="navbar-brand d-flex align-items-center logo" href="#">
      <img
        src="https://demo.alallamcleaning.com/uploads/malaz-no-bg.png"
        alt="logo"
      />
      <span className="ms-2">Hotel Management System</span>
    </a>

    {/* Hamburger */}
    <button
      className="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarContent"
    >
      <span className="navbar-toggler-icon"></span>
    </button>

    {/* Navbar Content */}
    <div className="collapse navbar-collapse" id="navbarContent">

      {/* Search (center on desktop) */}
      <div className="mx-lg-auto my-2 my-lg-0 w-lg-50">
        <input
          type="text"
          className="form-control"
          placeholder="Search Properties"
        />
      </div>

      {/* Right Section */}
      <div className="d-flex flex-column flex-lg-row align-items-lg-center gap-2 ms-lg-auto user-section">

        <span className="d-flex align-items-center">
          <User size={18} className="me-2" />
          Admin User
        </span>

        <button onClick={handleLogout} className="btn btn-success">
          Logout
        </button>

      </div>

    </div>
  </div>
</nav>

  {/* CONTENT */}
  <div className="content">
    <h4 className="fw-light">Hotel Rooms</h4>

    {loading ? (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
    <div className="spinner-grow text-success" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
    ) :
    rooms.length === 0 ? (
  
  <div className="no-results-wrapper">
    <div className="no-results">
      <h5>No rooms found</h5>
      <p>Try adjusting your filters or price range</p>

      <button
  className="btn btn-outline-primary mt-3"
  onClick={() => {
    const reset = {
      hotel_price_master_id: 1,
      minPrice: "",
      maxPrice: "",
    };

    setFilters(reset);
    setAppliedFilters(reset);
    fetchRooms(reset); 
  }}
>
  Reset Filters
</button>
    </div>
  </div>


):
     (
      <div className="row">
        {/* Filter Card */}
<div className="filter-card">
  <div className="section-title">
    <span className="filter-icon">🔍</span>
    Filter Rooms
  </div>

  <div className="row g-3 align-items-end">

    {/* Rate Plan */}
    <div className="col-12 col-md-5">
      <label className="form-label-sm">Rate Plan</label>
      <select
        className="form-select"
        value={filters.hotel_price_master_id}
        onChange={(e) =>
          setFilters({ ...filters, hotel_price_master_id: Number(e.target.value) })
        }
      >
        {priceRefs.map((p) => (
          <option key={p.hotel_price_master_id} value={p.hotel_price_master_id}>
            {p.hotel_price_name}
          </option>
        ))}
      </select>
    </div>

    {/* Min Price */}
    <div className="col-5 col-md-2">
      <label className="form-label-sm">Min Price</label>
      <input
        type="number"
        className="form-control"
        value={filters.minPrice}
        onChange={(e) => setFilters({ ...filters, minPrice: e.target.value })}
      />
    </div>

    {/* Divider */}
    <div className="col-2 col-md-1 d-flex justify-content-center">
      <span style={{ color: '#adb5bd', fontSize: '20px', paddingTop: '22px' }}>—</span>
    </div>

    {/* Max Price */}
    <div className="col-5 col-md-2">
      <label className="form-label-sm">Max Price</label>
      <input
        type="number"
        className="form-control"
        value={filters.maxPrice}
        onChange={(e) => setFilters({ ...filters, maxPrice: e.target.value })}
      />
    </div>

    {/* Apply Button */}
    <div className="col-12 col-md-2">
      <button
        className="btn-apply"
        onClick={() => {
          setAppliedFilters(filters);
          fetchRooms(filters);
        }}
      >
      <Search size={16} className="me-1"/>  Apply
      </button>
    </div>

  </div>
</div>
        {rooms.map((room) => (
          <div className="col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-4" key={room.hotel_room_master_id}>
  <div className="room-card h-100">

    {/* Image */}
    <img
      src={`https://realestate.alallamtech.com/demo/${room.hotel_room_image}`}
      alt={room.hotel_room_name}
      className="room-img"
    />

    {/* Body */}
    <div className="room-body">

      <h5 className="room-title">
        {room.hotel_room_name}
      </h5>

      {/* Info Row */}
      <div className="room-features">
        <span>📐 {room.hotel_room_size} m²</span>
        <span>🍽 {room.hotel_room_kitchen}</span>
        <span>🚭 {room.hotel_room_smoking}</span>
      </div>

      {/* Description */}
      <div
        className="room-desc"
        dangerouslySetInnerHTML={{
          __html: room.hotel_room_description
        }}
      />

      <button
        className="btn btn-custom w-100"
        onClick={() =>
          fetchPrices(room.hotel_room_master_id)
        }
      >
        View Details
      </button>

    </div>
  </div>
</div>
        ))}
      </div>
    )}
  </div>

  {/* OFFCANVAS */}
  <div
    className="offcanvas offcanvas-end"
    tabIndex="-1"
    id="priceOffcanvas"
  >
    <div className="offcanvas-header" style={{backgroundColor:'#f2f2f2'}}>
      <h5>Room Prices</h5>
      <button
        type="button"
        className="btn-close"
        data-bs-dismiss="offcanvas"
      ></button>
    </div>

    <div className="offcanvas-body">
      {priceLoading ? (
        <p>Loading prices...</p>
      ) : prices.length === 0 ? (
        <p>No prices found</p>
      ) : (
        prices.map((price) => (
          <div
            key={price.hotel_room_price_id}
            className="border-bottom py-2"
          >
            <div className="d-flex justify-content-between align-items-center">

              <span className="mb-0"><Calendar size={15} className="me-2"/>{price.hotel_price_name}</span>

              {editingId === price.hotel_room_price_id ? (
                <div className="d-flex gap-2">

                  <input
                    type="number"
                    className="form-control form-control-sm"
                    value={editAmount}
                    onChange={(e) => setEditAmount(e.target.value)}
                    style={{ width: "100px" }}
                  />

                  <button
                    className="btn btn-success btn-sm"
                    onClick={() =>
                      updatePrice(price.hotel_room_price_id)
                    }
                  >
                    Save
                  </button>

                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => setEditingId(null)}
                  >
                    Cancel
                  </button>

                </div>
              ) : (
                <div className="d-flex gap-2 align-items-center">

                  <strong>QR {price.hotel_price_amount}</strong>

                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => {
                      setEditingId(price.hotel_room_price_id);
                      setEditAmount(price.hotel_price_amount);
                    }}
                  >
                    Edit
                  </button>

                </div>
              )}

            </div>
          </div>
        ))
      )}
    </div>
  </div>

</div>

);
}
